import { render, staticRenderFns } from "./inbox-filter-index.vue?vue&type=template&id=82e2d5c0"
import script from "./inbox-filter-index.vue?vue&type=script&lang=js"
export * from "./inbox-filter-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports